"use client";
import Hyperlink from "@/components/ui/hyperlink";
import { getRecentBlogsClient } from "@/lib/blog-data";
import BlogAreaCard from "./blog-area-card";
import { useMemo } from "react";

interface Props {
    style?: "style-2";
}

const BlogArea = ({ style }: Props) => {
    // Get the latest 3 blog posts from the dynamic blog system
    const latestBlogs = useMemo(() => {
        const blogs = getRecentBlogsClient(3);
        return blogs.map(blog => ({
            title: blog.title,
            date: blog.date || new Date().toISOString().split('T')[0],
            imageUrl: "/images/blog/blog-thumb-1.png", // Default image
            url: `/blog/${blog.slug}`,
            tag: blog.tags[0] || "General",
            description: blog.short_description,
            author: blog.author
        }));
    }, []);

    return (
        <>
            <section
                className={`desilo-blog-section section-padding-top overflow-hidden ${style === "style-2" ? "bg-color-2" : ""
                    }`}
            >
                <div className="container custom-container">
                    <div className="row g-3 align-items-end">
                        <div className="col-12 col-lg-9 col-xl-7 col-xxl-6">
                            <div className="desilo__header text-left text-md-start">
                                <h2 className="title">
                                    Insights for owned growth
                                </h2>
                            </div>
                        </div>
                        <div className="col-12 col-lg-3 col-xl-5 col-xxl-6">
                            <div className="desilo__headerr d-flex justify-content-left justify-content-lg-end">
                                <Hyperlink href="/blog">
                                    View all blogs
                                </Hyperlink>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4 row-padding-top">
                        {/* blog card start */}
                        {latestBlogs.map((blog, i) => {
                            return (
                                <div
                                    key={i}
                                    className="col-md-6 col-xl-4"
                                >
                                    <BlogAreaCard data={blog} />
                                </div>
                            );
                        })}
                        {/* blog card end */}
                    </div>
                </div>
            </section>
        </>
    );
};

export default BlogArea;
